<template>
    <dl>
        <dt>主な症状</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer01 ) ? interviewAnswer.answer01 : '-'  }}</dd>

        <dt>症状が出た時期</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer02 ) ? interviewAnswer.answer02 : '-'  }}</dd>

        <dt>心配なこと・ご相談</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer03 ) ? interviewAnswer.answer03 : '-'  }}</dd>

        <dt>これまでにかかったおもな病気や手術</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer04 ) ? interviewAnswer.answer04 : '-'  }}</dd>

        <dt>じんましん、気分の悪化などを引き起こす薬や食べ物</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer06 ) ? interviewAnswer.answer06 : '-'  }}</dd>

        <dt>内服中の薬</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer08 ) ? interviewAnswer.answer08 : '-'  }}</dd>

        <dt>タバコの本数</dt>
        <dd>{{ interviewAnswer.answer10 }}<span class="ml-1">本／日</span></dd>

        <dt>飲酒の頻度</dt>
        <dd>週{{ interviewAnswer.answer11 }}回</dd>

        <dt>飲酒の量</dt>
        <dd><span class="mr-1">1回</span>{{ interviewAnswer.answer12 }}ml</dd>

        <dt>薬の希望</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer13 ) ? options.medicineAspiration[ interviewAnswer.answer13 ] : '-'  }}</dd>

        <dt>希望する薬の名称</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer14 ) ? interviewAnswer.answer14 : '-'  }}</dd>

        <dt>その他、薬に対する希望やお考え</dt>
        <dd class="u-mb3">{{ ( interviewAnswer.answer15 ) ? interviewAnswer.answer15 : '-'  }}</dd>

        <dt>検査の希望</dt>
        <dd>{{ ( interviewAnswer.answer16 ) ? options.checkupAspiration[ interviewAnswer.answer16 ] : '-'  }}</dd>

        <dt>症状詳細・備考</dt>
        <dd>{{ ( interviewAnswer.answer17 ) ? interviewAnswer.answer17 : '-'  }}</dd>
    </dl>
</template>

<script>
    export default {
        props: ['interviewAnswer'],
        data () {
            return {
                options: {
                    medicineAspiration: [
                        '検査の結果で、最適な薬・処方箋が欲しい',
                        'いつももらっている薬・処方箋が欲しい',
                        'できるならば薬は飲みたくない',
                        'その他',
                    ],
                    checkupAspiration: [
                        '納得できるまで、検査をして調べて欲しい',
                        'あまり検査は受けたくないが、必要であれば検査を受ける',
                        '検査は大きな病院で受けたいので、当院では不要',
                    ],
                },
            }
        },
    }
</script>

<style scoped>

</style>